import { h } from 'preact';

const Backdrop = ({ isOpen, setIsOpen, context }) => {
    const closeEvent = new CustomEvent(`${context}:close`);
    return <div
    className={`fixed cursor-pointer left-0 top-0 ${
      isOpen
        ? 'w-full h-full opacity-100 z-[40] bg-black/60 backdrop-blur-md'
        : 'w-0 h-0 opacity-0 -z-1'
    }`}
    onClick={() =>
      !context
        ? setIsOpen(false)
        : document.dispatchEvent(closeEvent)
    }
  />
}


export default Backdrop;
